document.addEventListener("DOMContentLoaded", () => {
  const navbarLogo = document.querySelector(".header__heading-logo");
  const navbarLogoWrapper = document.querySelector(".header__heading-logo-wrapper");

  if (!navbarLogo || !navbarLogoWrapper) return;

  const introLogo = navbarLogo.cloneNode(true);
  introLogo.classList.add("logo-intro");

  const header = document.querySelector("header")
    || document.querySelector(".header")
    || document.querySelector("#shopify-section-header");

  header.appendChild(introLogo);

  navbarLogoWrapper.style.opacity = "0";

  function updateLogoPosition() {
    const triggerHeight = window.innerHeight * 0.1;
    const scroll = Math.min(window.scrollY, triggerHeight);
    const progress = scroll / triggerHeight;

    const navRect = navbarLogo.getBoundingClientRect();
    const navX = navRect.left + navRect.width / 2;
    const navY = navRect.top + navRect.height / 2;

    const startX = window.innerWidth / 2;
    const startY = window.innerHeight / 2;

    const currentX = startX + (navX - startX) * progress;
    const currentY = startY + (navY - startY) * progress;

    const startScale = 1;
    const endScale = navRect.width / introLogo.offsetWidth;
    const currentScale = startScale + (endScale - startScale) * progress;

    introLogo.style.transform =
      `translate(${currentX}px, ${currentY}px) translate(-50%, -50%) scale(${currentScale})`;
  }

  window.addEventListener("scroll", updateLogoPosition);
  window.addEventListener("resize", updateLogoPosition);

  updateLogoPosition();

  requestAnimationFrame(() => {
    introLogo.classList.add("ready");
  });
});
